import { Chip, Grid } from "@mui/material";
import { UserIcon } from "@zfp-akademie-a-s/zfp-design/icons";
import { CoinsIcon } from "Components/_Shared/Icons/Icons";
import { Tile } from "Components/_Shared/Tile";
import { useGetAnalysisClients } from "Infrastructure/ApiZfp/AnalyzerApi";
import type { LiabilityItem } from "Infrastructure/ApiZfp/Schema";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { LIABILITY_SUBTYPE_RESOURCE_KEY } from "Infrastructure/Utils/AssetUtils";
import { formatClientName } from "Infrastructure/Utils/ClientUtils";
import { formatCurrency } from "Infrastructure/Utils/CurrencyUtils";
import { type FC, useContext } from "react";
import { AnalysisDetailContext } from "../Detail/AnalysisDetailContext";

type Props = {
  readonly liability: LiabilityItem;
  readonly onEdit: () => void;
};

export const LiabilityTile: FC<Props> = ({ liability, onEdit }) => {
  const { t } = useResource();
  const { versionId, analysisId } = useContext(AnalysisDetailContext);

  const { data: clientsData } = useGetAnalysisClients(analysisId, versionId);

  const client = clientsData?.clients.find((client) => client.guid === liability?.clientGuid);

  return (
    <Tile title={liability.name} subtitle={liability.note ?? undefined} onClick={onEdit}>
      <Grid container gap={Spacing.M}>
        <Chip
          size="small"
          label={t(Resources.AnalysisDetail.Assets.Liabilities.LiabilityType[LIABILITY_SUBTYPE_RESOURCE_KEY[liability.liabilitySubType]])}
        />
        <Chip size="small" icon={<CoinsIcon />} label={formatCurrency(liability.amount.value, liability.amount.currencyCode)} />
        {client && <Chip size="small" color="info" icon={<UserIcon />} label={formatClientName(client.firstName, client.surname, null)} />}
      </Grid>
    </Tile>
  );
};
